import { render, staticRenderFns } from "./GuppyChatSupportList.vue?vue&type=template&id=530281d2&"
import script from "./GuppyChatSupportList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatSupportList.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatSupportList.vue?vue&type=style&index=0&id=530281d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports